module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ed-Fb.d47b4618.png";